export default {
  // Navigation
  nav_categories: 'Categorias',
  nav_guides: 'Guias',
  nav_article: 'Artigo SEO',
  nav_spreadsheet: 'CSSBuy Spreadsheet',
  nav_lang: 'PT',
  nav_home: 'Início',
  nav_guide: 'Guia de Compras',
  search_placeholder: 'Buscar categoria...',
  related_content: 'Conteúdo Relacionado',
  back_to_home: 'Voltar para a página inicial',
  visit_main_site: 'Visitar o site principal',
  more_articles: 'Mais artigos',

  // Hero
  hero_title: 'CSSBuy Spreadsheet – Encontre Produtos, Guias e Recursos para Compras na China',
  hero_subtitle: 'Explore um recurso independente e organizado sobre CSSBuy Spreadsheet, com categorias de produtos, guias de compra, informações sobre QC, envio, armazém e dicas de segurança para ajudar você a pesquisar melhor antes de comprar.',
  hero_cta_primary: 'CSSBuy Spreadsheet',
  hero_cta_secondary: 'Buy It Now',
  hero_trust_1: 'Recurso Independente',
  hero_trust_2: 'Guias Práticos',
  hero_trust_3: 'Informações Organizadas',
  hero_trust_4: 'Atualizado Regularmente',

  // What Is Section
  what_is_title: 'O que é o CSSBuy Spreadsheet?',
  what_is_text: 'O CSSBuy Spreadsheet é uma forma prática de organizar e descobrir produtos, links e informações relacionadas ao processo de pesquisa de compras. Você pode explorar categorias e recursos organizados para facilitar sua pesquisa.',
  what_is_cta: 'Explorar o CSSBuy Spreadsheet',

  // Categories
  categories_title: 'Categorias de Produtos',
  categories_subtitle: 'Explore nossas categorias organizadas para encontrar produtos rapidamente',
  cat_shoes: 'Tênis',
  cat_hoodies: 'Moletons',
  cat_tshirts: 'Camisetas',
  cat_jackets: 'Jaquetas',
  cat_pants: 'Calças',
  cat_headwear: 'Bonés',
  cat_sets: 'Conjuntos',
  cat_underwear: 'Underwear',
  cat_jersey: 'Jersey',
  cat_accessories: 'Acessórios',
  cat_bags: 'Bolsas',
  cat_belts: 'Cintos',
  cat_perfumes: 'Perfumes',
  cat_other: 'Outros',

  // Benefits
  benefits_title: 'Por que usar um CSSBuy Spreadsheet?',
  benefits_subtitle: 'Descubra as vantagens de organizar sua pesquisa de produtos',
  benefit_1_title: 'Encontre produtos com mais rapidez',
  benefit_1_text: 'Navegue por categorias organizadas e encontre exatamente o que procura sem perder tempo.',
  benefit_2_title: 'Organize links e categorias',
  benefit_2_text: 'Mantenha todos os seus links e produtos favoritos organizados em um só lugar.',
  benefit_3_title: 'Compare informações antes de comprar',
  benefit_3_text: 'Acesse guias detalhados e compare opções para tomar decisões informadas.',
  benefit_4_title: 'Consulte guias e dicas de QC',
  benefit_4_text: 'Aprenda a verificar a qualidade dos produtos antes de finalizar sua compra.',
  benefit_5_title: 'Entenda melhor as opções de envio',
  benefit_5_text: 'Conheça as diferentes modalidades de envio e escolha a melhor para você.',

  // How It Works
  how_title: 'Como Funciona',
  how_subtitle: 'Siga estes passos simples para aproveitar o CSSBuy Spreadsheet',
  step_1: 'Encontre um produto',
  step_1_text: 'Navegue pelas categorias e encontre itens que te interessam.',
  step_2: 'Consulte o CSSBuy Spreadsheet',
  step_2_text: 'Acesse nossos recursos organizados para mais informações.',
  step_3: 'Verifique as informações',
  step_3_text: 'Confira detalhes, guias e dicas antes de prosseguir.',
  step_4: 'Verifique QC quando disponível',
  step_4_text: 'Analise fotos de qualidade e avaliações quando possível.',
  step_5: 'Pesquise envio e custos',
  step_5_text: 'Entenda as opções de envio e calcule os custos.',
  step_6: 'Verifique antes de comprar',
  step_6_text: 'Confirme todas as informações antes de finalizar.',
  step_7: 'Continue para o site principal',
  step_7_text: 'Acesse kaspreadsheet.com para completar sua compra.',

  // Safety
  safety_title: 'Segurança em Primeiro Lugar',
  safety_text: 'Nunca compartilhe sua senha ou dados de pagamento com terceiros desconhecidos. Confirme sempre o domínio antes de inserir informações. Preços, produtos e informações de envio podem mudar, portanto verifique os dados atuais antes de comprar.',
  safety_cta: 'Ver Guia de Segurança',

  // Articles
  articles_title: 'Artigos e Guias',
  articles_subtitle: 'Conteúdo original para ajudar você a navegar no CSSBuy Spreadsheet',
  read_more: 'Ler mais',

  // Article card
  article_1_title: 'O que é CSSBuy Spreadsheet? Guia Completo para Iniciantes',
  article_1_desc: 'Descubra como o CSSBuy Spreadsheet funciona, como usar as categorias organizadas e como aproveitar ao máximo este recurso para sua pesquisa de produtos.',
  article_1_date: '28 de agosto de 2026',

  // Footer
  footer_disclaimer: 'Este site é um recurso informativo independente e não é afiliado à CSSBuy.',
  footer_privacy: 'Privacidade',
  footer_terms: 'Termos',
  footer_contact: 'Contato',
  footer_copyright: '© 2026 CSSBuy Spreadsheet Resource. Todos os direitos reservados.',

  // Dropdown
  dropdown_title: 'Selecionar Categoria',
  dropdown_all: 'Todas as Categorias',

  // Disclaimer
  disclaimer: 'This website is an independent informational resource and is not affiliated with, operated by, or endorsed by CSSBuy.',

  // CTA buttons
  cta_main_site: 'Visitar Site Principal',
  cta_explore: 'Explorar agora',
  cta_view_products: 'Ver Produtos',
  cta_title: 'Pronto para explorar o CSSBuy Spreadsheet?',
  cta_subtitle: 'Pesquise produtos, consulte nossos guias e encontre recursos organizados para facilitar sua pesquisa.',

  // 404
  not_found_title: 'Página não encontrada',
  not_found_text: 'A página que você procura não existe.',
  not_found_back: 'Voltar para Home',
};